import { observe } from 'mobx';
import { useEffect } from 'react';
import { history } from '../stores/history';
import useStores from './useStores';

const useStats = () => {
  const { sessionStore, statsStore } = useStores();

  const sendStats = () => {
    const { user } = sessionStore;
    if (!user) return;

    statsStore.setPagePath(history.location.pathname);
    statsStore.setNeighborId(user?.user_id);
    statsStore.sendStats();
  };

  const unlisten = history.listen(() => {
    sendStats();
  });

  const disposer = observe(sessionStore, 'user', (change) => {
    if (change.newValue) {
      sendStats();
    }
  });

  useEffect(
    () => () => {
      disposer();
      unlisten();
    },
    [disposer, unlisten],
  );
};

export default useStats;
